import styled from 'styled-components'
import firstImage from 'images/training/prop22/01-sheila-and-hatchback.png'
import secondImage from 'images/training/prop22/02-drive-safely-icon.png'
import thirdImage from 'images/training/prop22/03-defensive-driving-icon.png'
import fourthImage from 'images/training/prop22/11-alert-icon.png'
import fifthImage from 'images/training/prop22/05-kevin-and-groceries.png'
import sixthImage from 'images/training/prop22/06-cold-chain-icon.png'
import seventhImage from 'images/training/prop22/09-roadie-community.png'
import eighthImage from 'images/training/prop22/10-hostile-environment-icon.png'
import ninthImage from 'images/training/prop22/12-great-job.png'
import { Overline, H4, H5, H6, Body2 } from 'components/layout/text'
import Spacer from 'components/misc/Spacer'
import { ExternalLinkButton } from 'components/layout/buttons'
import { Container, Module, Slide } from 'components/pages/certifications/framework'
import { TRAINING_CERTS } from 'util/constants'
import { LocalizedText, useLocalization } from 'localization'

const WideImg = styled.img`
  width: 320px;
  height: auto;
  margin: 0 auto;
  align-self: flex-start;
`

const SmallImg = styled.img`
  width: 120px;
  height: auto;
  margin: 0 auto;
  align-self: flex-start;
`

const ImgContainer = styled.div`
  width: 100%;
  display: flex;
`

const List = styled.ul`
  margin: 0;
  padding-left: 22px;
`

const ListItem = styled.li`
  font-size: 14px;
  color: ${(props) => props.theme.colors.black};

  ${Body2} {
    position: relative;
    left: 5px;
    width: calc(100% - 5px);
  }
`

const Prop22Page = () => {
  const { t } = useLocalization()

  return (
    <Container title={t('dweb_certifications_prop22_prop22_driver_safety_training')}>
      <Module certification={TRAINING_CERTS.PROP22}>
        <Slide>
          <ImgContainer>
            <WideImg src={firstImage} />
          </ImgContainer>
          <Spacer height="2.5rem" />
          <Overline weight="500" color="primaryBase">
            <LocalizedText translationKey="dweb_certifications_prop22_prop22_road_roadie" />
          </Overline>
          <Spacer height=".8rem" />
          <H4>
            <LocalizedText translationKey="dweb_certifications_prop22_prop22_tips_driving_safely" />
          </H4>
          <Spacer height=".8rem" />
          <Body2>
            <LocalizedText translationKey="dweb_certifications_prop22_safety_training_intro" />
          </Body2>
          <Spacer height="3.2rem" />
        </Slide>

        <Slide>
          <ImgContainer>
            <SmallImg src={secondImage} />
          </ImgContainer>
          <Spacer height="3.2rem" />
          <H4>
            <LocalizedText translationKey="dweb_certifications_prop22_prop22_practice_safe_driving" />
          </H4>
          <Spacer height="1.6rem" />
          <H6>
            <LocalizedText translationKey="dweb_certifications_prop22_prop22_cut_out_distractions" />
          </H6>
          <Spacer height="1.6rem" />
          <List>
            <ListItem>
              <Body2>
                <LocalizedText translationKey="dweb_certifications_prop22_distraction_definition" />
              </Body2>
            </ListItem>
            <Spacer height="1.6rem" />
            <ListItem>
              <Body2>
                <LocalizedText translationKey="dweb_certifications_prop22_avoid_distractions" />
              </Body2>
            </ListItem>
            <Spacer height="1.6rem" />
            <ListItem>
              <Body2>
                <LocalizedText translationKey="dweb_certifications_prop22_hands_free_devices" />
              </Body2>
            </ListItem>
          </List>
          <Spacer height="3.2rem" />
          <H6>
            <LocalizedText translationKey="dweb_certifications_prop22_prop22_never_drive_while_intoxicated" />
          </H6>
          <Spacer height="1.6rem" />
          <List>
            <ListItem>
              <Body2>
                <LocalizedText translationKey="dweb_certifications_prop22_prop22_one_benefits_side_hustle_always_have_choice_stay" />
              </Body2>
            </ListItem>
          </List>
          <Spacer height="3.2rem" />
        </Slide>

        <Slide>
          <ImgContainer>
            <SmallImg src={thirdImage} />
          </ImgContainer>
          <Spacer height="3.2rem" />
          <H4>
            <LocalizedText translationKey="dweb_certifications_prop22_prop22_avoid_accidents_defensive_driving" />
          </H4>
          <Spacer height=".4rem" />
          <Body2>
            <LocalizedText translationKey="dweb_certifications_prop22_crash_statistics_intro" />
          </Body2>
          <Spacer height="3.2rem" />
          <H6>
            <LocalizedText translationKey="dweb_certifications_prop22_prop22_think_safety_first" />
          </H6>
          <Spacer height="1.6rem" />
          <List>
            <ListItem>
              <Body2>
                <LocalizedText translationKey="dweb_certifications_prop22_defensive_driving_benefit" />
              </Body2>
            </ListItem>
            <Spacer height="1.6rem" />
            <ListItem>
              <Body2>
                <LocalizedText translationKey="dweb_certifications_prop22_prop22_leave_plenty_space_between_car_front" />
              </Body2>
            </ListItem>
            <Spacer height="1.6rem" />
            <ListItem>
              <Body2>
                <LocalizedText translationKey="dweb_certifications_prop22_prop22_always_lock_doors_wear_seatbelt_protect_from_being" />
              </Body2>
            </ListItem>
          </List>
          <Spacer height="3.2rem" />
          <H6>
            <LocalizedText translationKey="dweb_certifications_prop22_prop22_pay_attention" />
          </H6>
          <Spacer height="1.6rem" />
          <List>
            <ListItem>
              <Body2>
                <LocalizedText translationKey="dweb_certifications_prop22_mirror_scan_tip" />
              </Body2>
            </ListItem>
            <Spacer height="1.6rem" />
            <ListItem>
              <Body2>
                <LocalizedText translationKey="dweb_certifications_prop22_prop22_keep_eye_pedestrians_bicyclists_pets_along_road" />
              </Body2>
            </ListItem>
            <Spacer height="1.6rem" />
            <ListItem>
              <Body2>
                <LocalizedText translationKey="dweb_certifications_prop22_avoid_aggressive_driver" />
              </Body2>
            </ListItem>
            <Spacer height="1.6rem" />
            <ListItem>
              <Body2>
                <LocalizedText translationKey="dweb_certifications_prop22_avoid_dangerous_driver" />
              </Body2>
            </ListItem>
          </List>
          <Spacer height="3.2rem" />
          <H6>
            <LocalizedText translationKey="dweb_certifications_prop22_prop22_dont_depend_other_drivers" />
          </H6>
          <Spacer height="1.6rem" />
          <List>
            <ListItem>
              <Body2>
                <LocalizedText translationKey="dweb_certifications_prop22_anticipate_worst_case" />
              </Body2>
            </ListItem>
            <Spacer height="1.6rem" />
            <ListItem>
              <Body2>
                <LocalizedText translationKey="dweb_certifications_prop22_prop22_dont_assume_another_driver_going_move_out_way" />
              </Body2>
            </ListItem>
          </List>
          <Spacer height="3.2rem" />
          <H6>
            <LocalizedText translationKey="dweb_certifications_prop22_prop22_follow_4_second_rule" />
          </H6>
          <Spacer height="1.6rem" />
          <List>
            <ListItem>
              <Body2>
                <LocalizedText translationKey="dweb_certifications_prop22_normal_following_distance" />
              </Body2>
            </ListItem>
            <Spacer height="1.6rem" />
            <ListItem>
              <Body2>
                <LocalizedText translationKey="dweb_certifications_prop22_bad_weather_following_distance" />
              </Body2>
            </ListItem>
          </List>
          <Spacer height="3.2rem" />
          <H6>
            <LocalizedText translationKey="dweb_certifications_prop22_prop22_keep_speed_down" />
          </H6>
          <Spacer height="1.6rem" />
          <List>
            <ListItem>
              <Body2>
                <LocalizedText translationKey="dweb_certifications_prop22_speed_limit_conditions" />
              </Body2>
            </ListItem>
          </List>
          <Spacer height="3.2rem" />
        </Slide>

        <Slide>
          <ImgContainer>
            <SmallImg src={fourthImage} />
          </ImgContainer>
          <Spacer height="3.2rem" />
          <H4>
            <LocalizedText translationKey="dweb_certifications_prop22_prop22_learn_how_spot_collision_causing_elements" />
          </H4>
          <Spacer height=".4rem" />
          <Body2>
            <LocalizedText translationKey="dweb_certifications_prop22_collision_risks" />
          </Body2>
          <Spacer height="1.6rem" />
          <List>
            <ListItem>
              <Body2>
                <LocalizedText translationKey="dweb_certifications_prop22_prop22_making_wide_turns" />
              </Body2>
            </ListItem>
            <Spacer height="1.6rem" />
            <ListItem>
              <Body2>
                <LocalizedText translationKey="dweb_certifications_prop22_prop22_weaving_swerving_drifting_crossing_center_line" />
              </Body2>
            </ListItem>
            <Spacer height="1.6rem" />
            <ListItem>
              <Body2>
                <LocalizedText translationKey="dweb_certifications_prop22_prop22_almost_striking_object_vehicle" />
              </Body2>
            </ListItem>
            <Spacer height="1.6rem" />
            <ListItem>
              <Body2>
                <LocalizedText translationKey="dweb_certifications_prop22_prop22_driving_wrong_side_road" />
              </Body2>
            </ListItem>
            <Spacer height="1.6rem" />
            <ListItem>
              <Body2>
                <LocalizedText translationKey="dweb_certifications_prop22_prop22_driving_at_very_slow_speed" />
              </Body2>
            </ListItem>
            <Spacer height="1.6rem" />
            <ListItem>
              <Body2>
                <LocalizedText translationKey="dweb_certifications_prop22_prop22_stopping_without_cause" />
              </Body2>
            </ListItem>
            <Spacer height="1.6rem" />
            <ListItem>
              <Body2>
                <LocalizedText translationKey="dweb_certifications_prop22_prop22_braking_erratically" />
              </Body2>
            </ListItem>
            <Spacer height="1.6rem" />
            <ListItem>
              <Body2>
                <LocalizedText translationKey="dweb_certifications_prop22_prop22_responding_slowly_traffic_signals" />
              </Body2>
            </ListItem>
            <Spacer height="1.6rem" />
            <ListItem>
              <Body2>
                <LocalizedText translationKey="dweb_certifications_prop22_prop22_turning_abruptly_illegally" />
              </Body2>
            </ListItem>
            <Spacer height="1.6rem" />
            <ListItem>
              <Body2>
                <LocalizedText translationKey="dweb_certifications_prop22_prop22_driving_after_dark_headlights_off" />
              </Body2>
            </ListItem>
          </List>
          <Spacer height="3.2rem" />
        </Slide>

        <Slide>
          <ImgContainer>
            <WideImg src={fifthImage} />
          </ImgContainer>
          <Spacer height="3.2rem" />
          <Overline weight="500" color="primaryBase">
            <LocalizedText translationKey="dweb_certifications_prop22_prop22_road_roadie" />
          </Overline>
          <Spacer height=".8rem" />
          <H4>
            <LocalizedText translationKey="dweb_certifications_prop22_prop22_tips_food_safety" />
          </H4>
          <Spacer height=".4rem" />
          <Body2>
            <LocalizedText translationKey="dweb_certifications_prop22_food_safety_intro" />
          </Body2>
          <Spacer height="3.2rem" />
          <ImgContainer>
            <SmallImg src={sixthImage} />
          </ImgContainer>
          <Spacer height="3.2rem" />
          <H5 weight="bold">
            <LocalizedText translationKey="dweb_certifications_prop22_prop22_keep_cold_foods_cold" />
          </H5>
          <Spacer height="1.6rem" />
          <H6>
            <LocalizedText translationKey="dweb_certifications_prop22_prop22_remember_cold_chain_compliance" />
          </H6>
          <Spacer height="1.6rem" />
          <Body2>
            <LocalizedText translationKey="dweb_certifications_prop22_prop22_gigs_have_time_limit_reason_but_its_more" />
          </Body2>
          <Spacer height="1.6rem" />
          <Body2>
            <LocalizedText translationKey="dweb_certifications_prop22_perishable_delivery_window" />
          </Body2>
          <Spacer height="1.6rem" />
          <List>
            <ListItem>
              <Body2>
                <LocalizedText translationKey="dweb_certifications_prop22_temperature_control" />
              </Body2>
            </ListItem>
            <Spacer height="1.6rem" />
            <ListItem>
              <Body2>
                <LocalizedText translationKey="dweb_certifications_prop22_food_contamination_tip" />
              </Body2>
            </ListItem>
            <Spacer height="1.6rem" />
            <ListItem>
              <Body2>
                <LocalizedText translationKey="dweb_certifications_prop22_prop22_return_items_need_back_at_store_within_1" />
              </Body2>
            </ListItem>
          </List>
          <Spacer height="3.2rem" />
          <H6>
            <LocalizedText translationKey="dweb_certifications_prop22_prop22_stay_covid_safe" />
          </H6>
          <Spacer height="1.6rem" />
          <List>
            <ListItem>
              <Body2>
                <LocalizedText translationKey="dweb_certifications_prop22_prop22_wear_mask_gloves_any_time_handle_food_groceries" />
              </Body2>
            </ListItem>
            <Spacer height="1.6rem" />
            <ListItem>
              <Body2>
                <LocalizedText translationKey="dweb_certifications_prop22_cdc_food_delivery_guidance" />
              </Body2>
            </ListItem>
          </List>
          <Spacer height="3.2rem" />
        </Slide>

        <Slide>
          <ImgContainer>
            <WideImg src={seventhImage} />
          </ImgContainer>
          <Spacer height="3.2rem" />
          <Overline weight="500" color="primaryBase">
            <LocalizedText translationKey="dweb_certifications_prop22_prop22_respect_our_community" />
          </Overline>
          <Spacer height=".8rem" />
          <H4>
            <LocalizedText translationKey="dweb_certifications_prop22_prop22_sexual_assault_misconduct" />
          </H4>
          <Spacer height=".4rem" />
          <Body2>
            <LocalizedText translationKey="dweb_certifications_prop22_harassment_definition" />
          </Body2>
          <Spacer height="3.2rem" />
          <ImgContainer>
            <SmallImg src={eighthImage} />
          </ImgContainer>
          <Spacer height="3.2rem" />
          <H5 weight="bold">
            <LocalizedText translationKey="dweb_certifications_prop22_prop22_what_need_know" />
          </H5>
          <Spacer height="1.6rem" />
          <H6>
            <LocalizedText translationKey="dweb_certifications_prop22_prop22_what_sexual_harassment" />
          </H6>
          <Spacer height="1.6rem" />
          <List>
            <ListItem>
              <Body2>
                <LocalizedText translationKey="dweb_certifications_prop22_misconduct_examples" />
              </Body2>
            </ListItem>
            <Spacer height="1.6rem" />
            <ListItem>
              <Body2>
                <LocalizedText translationKey="dweb_certifications_prop22_harassment_examples" />
              </Body2>
            </ListItem>
            <Spacer height="1.6rem" />
            <ListItem>
              <Body2>
                <LocalizedText translationKey="dweb_certifications_prop22_prop22_sexual_harassment_assault_can_happen_at_any_time" />
              </Body2>
            </ListItem>
          </List>
          <Spacer height="3.2rem" />
          <Body2>
            <LocalizedText translationKey="dweb_certifications_prop22_harassment_policy_review" />
          </Body2>
          <Spacer height="3.2rem" />
        </Slide>

        <Slide>
          <ImgContainer>
            <WideImg src={ninthImage} />
          </ImgContainer>
          <Spacer height="3.2rem" />
          <H4>
            <LocalizedText translationKey="dweb_certifications_prop22_prop22_great_job" />
          </H4>
          <Spacer height=".4rem" />
          <Body2>
            <LocalizedText translationKey="dweb_certifications_prop22_completion_message" />
          </Body2>
          <Spacer height="1.6rem" />
          <Body2>
            <LocalizedText translationKey="dweb_certifications_prop22_prop22_please_download_our_safety_handbook_so_youll_have" />
          </Body2>
          <Spacer height="3.2rem" />
          <ExternalLinkButton
            mode="secondary"
            target="_blank"
            href="https://www.roadie.com/wp-content/uploads/2021/02/Tips-for-Driving-Safely-Prop-22.pdf"
          >
            <LocalizedText translationKey="dweb_certifications_prop22_prop22_download_pdf" />
          </ExternalLinkButton>
          <Spacer height="3.2rem" />
        </Slide>
      </Module>
    </Container>
  )
}

export default Prop22Page
